// src/components/AccountSelector.jsx
import React, { useState } from 'react';
import { Box, createFilterOptions, Typography, Checkbox, Autocomplete, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const filter = createFilterOptions();

export default function AccountSelector({ selected, setSelected, options, loading }) {
  // `selected` and `setSelected` are managed in parent (CalculatorPage) for stepper consistency

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Select Accounts
      </Typography>
      <Autocomplete
        multiple
        options={options}
        loading={loading}
  filterOptions={(options, { inputValue }) =>
    options.filter(option => {
      // Allow search by DBA, account number, or id substring
      const search = inputValue.trim().toLowerCase();
      return (
        option.name.toLowerCase().includes(search) ||
        option.id.toLowerCase().includes(search)
      );
    })
  }
getOptionLabel={option => option.name}
        value={selected}
        onChange={(_, value) => setSelected(value)}
        disableCloseOnSelect
renderOption={(props, option, { selected }) => {
  const { key, ...rest } = props;
  return (
    <li key={option.id} {...rest}>
      <Checkbox checked={selected} />
      {option.name}
    </li>
  );
}}
        renderInput={(params) => (
          <TextField {...params} label="Search by Account Number" placeholder="Type at least 3 digits..." />
        )}
        sx={{ mb: 3 }}
      />

      {/* Selected accounts summary */}
      {selected.length > 0 && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Account ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell align="right">Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selected.map((account) => (
                <TableRow key={account.id}>
                  <TableCell>{account.account}</TableCell>
                  <TableCell>{account.dba}</TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() =>
                        setSelected(selected.filter((a) => a.id !== account.id))
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
